"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGalleryImage = exports.galleryImageRuleSet = exports.isGalleryImageSource = exports.THUMBNAIL_SIZES = exports.AUTO_ORIENTED_SUFFIX = exports.ORIGINAL_SUFFIX = void 0;
exports.getS3Url = getS3Url;
exports.getGalleryImageThumbUrl = getGalleryImageThumbUrl;
exports.isGalleryImageUploaded = isGalleryImageUploaded;
const typeguard_1 = require("../types/typeguard");
const env_1 = require("../utils/env");
const GalleryImageMetadata_1 = require("./GalleryImageMetadata");
exports.ORIGINAL_SUFFIX = '_original';
exports.AUTO_ORIENTED_SUFFIX = '_autoOriented';
exports.THUMBNAIL_SIZES = [300, 600, 1200];
const isGalleryImageSource = gis => {
  return gis === 'local' || gis === 'google' || gis === 'dropbox' || gis === 'facebook' || gis === 'instagram';
};
exports.isGalleryImageSource = isGalleryImageSource;
exports.galleryImageRuleSet = {
  id: typeguard_1.isNonEmptyString,
  galleryId: typeguard_1.isNonEmptyString,
  createdBy: typeguard_1.isNonEmptyString,
  createdAt: typeguard_1.isNonEmptyString,
  source: exports.isGalleryImageSource,
  userAgent: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  lastModifiedAt: typeguard_1.isNonEmptyString,
  markedAsDeleted: typeguard_1.isBool,
  autoOriented: (0, typeguard_1.optional)(typeguard_1.isBool),
  metadata: GalleryImageMetadata_1.isGalleryImageMetadata
};
const isGalleryImage = g => {
  return (0, typeguard_1.isType)(g, exports.galleryImageRuleSet);
};
exports.isGalleryImage = isGalleryImage;
function getS3Url(galleryImage) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '300';
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (s3BaseUrl.isLeft()) {
    return undefined;
  }
  return `${s3BaseUrl.value}/${galleryImage.createdBy}/${galleryImage.id}_${size}`;
}
function getGalleryImageThumbUrl(userId, imageId) {
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (!s3BaseUrl) {
    console.warn('s3BaseUrl not defined');
    return undefined;
  }
  // TODO: Replace this with fastly image optimizer?
  return `${s3BaseUrl.value}/${userId}/${imageId}_300`;
}
function isGalleryImageUploaded(galleryImage) {
  return galleryImage.uploaded || galleryImage.uploaded == null && !!galleryImage.metadata;
}